import React from 'react';
import { powerReviewsData } from '../../../tng-common/src/scripts/power-reviews';

type PRsingleReviewProps = {
  offerId: string;
  className?: string;
  class?: string;
};
class PRsingleReview extends React.Component<PRsingleReviewProps> {
  componentDidMount() {
    this.loadReview(this.props.offerId);
  }

  loadReview(offerId: string) {
    const renderReview = () => {
      if (typeof window !== 'undefined') {
        const component = {
          ReviewDisplay: 'pr-reviewdisplay'
        };
        window.POWERREVIEWS.display.render({
          api_key: powerReviewsData.api_key,
          locale: powerReviewsData.locale,
          merchant_group_id: powerReviewsData.merchant_group_id,
          merchant_id: powerReviewsData.merchant_id,
          page_id: offerId,
          review_wrapper_url: `/help/write-review/?pr_page_id=${offerId}`,
          REVIEW_DISPLAY_PAGINATION_TYPE: 'VERTICAL',
          components: component
        });
      }
    };
    if (typeof window !== 'undefined' && !window.POWERREVIEWS) {
      const script = document.createElement('script');
      script.src = powerReviewsData.script;
      script.async = true;
      script.onload = () => {
        renderReview();
      };
      document.head.appendChild(script);
    } else {
      renderReview();
    }
  }

  render() {
    const classN = this.props.class || this.props.className || '';
    return (
      <div
        id="pr-reviewdisplay"
        className={`${classN}`}
      />
    );
  }
}

export default PRsingleReview;
